/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';

const getSigninStep = (state: any) => state.getIn(['loginReducer', 'signinStep']);
const getCurrentUserDetails = (state: any) => state.getIn(['loginReducer', 'currentUserDetails']);
const getEnteredWrongPassword = (state: any) => state.getIn(['loginReducer', 'enteredWrongPassword']);
const getUserMappedToOtherAgent = (state: any) => state.getIn(['loginReducer', 'userMappedToOtherAgent']);
const getOtpVerified = (state: any) => state.getIn(['loginReducer', 'otpVerified']);
const getIncorrectOtp = (state: any) => state.getIn(['loginReducer', 'incorrectOtp']);
const getportfolioDetails = (state: any) => state.getIn(['loginReducer', 'portfolioDetails']);
const getuserPasswordNotPresent = (state: any) => state.getIn(['loginReducer', 'userPasswordNotPresent']);
const getPartnerDetails = (state: any) => state.getIn(['loginReducer', 'isAgentVerified']);
const LoginSelector = createSelector(
    [getSigninStep, getCurrentUserDetails, getEnteredWrongPassword, getUserMappedToOtherAgent, getOtpVerified, getIncorrectOtp, getportfolioDetails, getuserPasswordNotPresent, getPartnerDetails],
    (signinStep, currentUserDetails, enteredWrongPassword, userMappedToOtherAgent, otpVerified, incorrectOtp, portfolioDetails, userPasswordNotPresent, isAgentVerified) => ({
        signinStep, currentUserDetails, enteredWrongPassword, userMappedToOtherAgent, otpVerified, incorrectOtp, portfolioDetails, userPasswordNotPresent, isAgentVerified
    })
);

export default LoginSelector;